export const ANALYTICS_TIMEFRAME = Object.freeze({
  LAST_SEVEN: "last-seven",
  LAST_THIRTY: "last-thirty",
  ALL_TIME: "all-time",
});

export const ANALYTICS_DATAPOINTS = Object.freeze({
  ACTIVE_USERS: "active-users",
  SESSIONS: "sessions",
  USAGE_TIME: "usage-time",
  SEARCHES: "searches",
  SOURCES: "sources",
  OTHER: "other",
});

export const ANALYTICS_STAT_TYPES = Object.freeze({
  TIME: "time",
  PERCENTAGE: "percentage",
  NUMBER: "number",
});

export const ANALYTICS_STATS = Object.freeze({
  PERCENTAGE: "percentage",
  TOTAL: "total",
  AVERAGE_USER: "average-user",
  GROUP_TOTAL: "group-total",
});
